import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './Header.css';

const Header = ({
  isHidden,
  welcomeMessage = "Welcome to Online Crackers",
  contactName = "Vetrivel",
  contactPhone = "+91 7667533653",
  logo = null,
  cartCount = 0
}) => {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [submenuOpen, setSubmenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [cartProductCount, setCartProductCount] = useState(cartCount);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 900);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  useEffect(() => {
    // Function to update cart count from localStorage
    const updateCartProductCount = () => {
      const cart = JSON.parse(localStorage.getItem('cartProducts') || '[]');
      setCartProductCount(cart.length);
    };

    // Initial load
    updateCartProductCount();

    // Listen for custom cart update events (same tab)
    const handleCartUpdate = () => {
      updateCartProductCount();
    };

    // Listen for storage events (different tabs)
    const handleStorageChange = (e) => {
      if (e.key === 'cartProducts') {
        updateCartProductCount();
      }
    };

    window.addEventListener('cartCountUpdate', handleCartUpdate);
    window.addEventListener('storage', handleStorageChange);

    return () => {
      window.removeEventListener('cartCountUpdate', handleCartUpdate);
      window.removeEventListener('storage', handleStorageChange);
    };
  }, [cartCount]);

  // Always use cartProductCount for cartCount display and logic
  const handleCartClick = () => {
     // Retrieve user details from localStorage or state
  const userDetails = JSON.parse(localStorage.getItem('userDetails')) || {};
  const cartProducts = JSON.parse(localStorage.getItem('cartProducts')) || [];

    const calculateTotals = (cartProducts) => {
  let totalAmount = 0;
  let discountTotal = 0;

  cartProducts.forEach(product => {
    totalAmount += (Number(product.quantity) || 0) * (Number(product.actual_rate) || 0);
    discountTotal += (Number(product.quantity) || 0) * (Number(product.discount_amount) || 0);
  });

  const netRate = totalAmount - discountTotal;
  return { totalAmount, discountTotal, netRate, finalAmount: netRate };
};
  const { finalAmount } = calculateTotals(cartProducts);

    if (cartProductCount > 0) {

      
  // Validate user details
  if (!userDetails.name || !userDetails.mobile || !userDetails.address) {
    alert('Please fill in all required user details (Name, Mobile, Address) before accessing the cart.');
    return;
  }

  // Validate minimum order amount
  if (finalAmount < 3000) {
    alert('Minimum order amount should be ₹3000. Please add more items to your cart.');
    return;
  }

      navigate('/cart',{
    state: {
      finalAmount,
      userDetails: JSON.parse(localStorage.getItem('userDetails')) || {},
    },
  });
    } else {
      alert('Add at least one product to cart!');
    }
  };

  // Close menu when navigating
  const handleMenuLinkClick = () => {
    setMenuOpen(false);
    setSubmenuOpen(false);
  };

  // Toggle submenu only in mobile view
  const handleSubmenuToggle = (e) => {
    e.preventDefault();
    setSubmenuOpen((prev) => !prev);
  };

  return (
    <header className={`header ${isHidden ? 'hidden' : ''}`} aria-hidden={isHidden}>
      {/* Disclaimer Marquee */}
      <div className="disclaimer-marquee">
        <div className="disclaimer-text">
          As per the supreme court order, Online sale of firecrackers is not permitted ! Don't worry, Request a quote with us and get the details of our crackers, Please add and submit your Enquiry.
        </div>
      </div>
      <nav className="header-nav" style={{ flexWrap: 'wrap', padding: '0 12px', position: 'relative' }}>
        {/* Menu toggle button on the left */}
        <button
          className="menu-toggle"
          aria-label="Toggle menu"
          style={{
            background: '#fff',
            border: 'none',
            color: '#222',
            fontSize: 28,
            position: 'absolute',
            top: 12,
            left: 16,
            zIndex: 20,
            display: isMobile ? 'block' : 'none',
            borderRadius: '50%',
            width: 40,
            height: 40,
            boxShadow: '0 2px 8px #0002'
          }}
          onClick={() => {
            setMenuOpen(!menuOpen);
            setSubmenuOpen(false);
          }}
        >
          ☰
        </button>

        {/* Centered logo */}
        <div className="header-logo-section" style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
          position: 'absolute',
          left: 0,
          top: 0,
          height: '100%',
          pointerEvents: 'none',
          zIndex: 1
        }}>
          <h6
            className="brand-title"
            style={{
              margin: 0,
              color: '#fff',
              fontWeight: 'bold',
              letterSpacing: '4px',
              textShadow: '0 2px 12px #000, 0 0 18px #FFD700, 0 0 32px #FF4500',
              fontSize: '1.3rem',
              width: '100%',
              textAlign: 'center',
              pointerEvents: 'auto'
            }}
          >
            Online Crackers
          </h6>
        </div>

        {/* Navigation menu */}
        <ul
          className={`header-menu${menuOpen ? ' open' : ''}`}
          style={{
            display: menuOpen ? 'block' : '',
            flexDirection: menuOpen ? 'column' : 'row',
            gap: menuOpen ? 0 : 32,
            listStyle: 'none',
            margin: 0,
            padding: menuOpen ? '12px 0' : 0,
            background: menuOpen ? '#fff' : 'none',
            position: menuOpen ? 'absolute' : 'static',
            top: menuOpen ? 60 : 'auto',
            left: 0,
            width: menuOpen ? '100%' : 'auto',
            zIndex: 10,
            boxShadow: menuOpen ? '0 2px 8px #0002' : 'none'
          }}
        >
          <li><Link to="/" onClick={handleMenuLinkClick}>Home</Link></li>
          <li><Link to="/about" onClick={handleMenuLinkClick}>About</Link></li>
          <li className="submenu-container">
            <Link
              to="/products"
              onClick={menuOpen ? handleSubmenuToggle : handleMenuLinkClick}
              style={{ position: 'relative' }}
            >
              Products
              {menuOpen && (
                <span style={{
                  marginLeft: 8,
                  fontSize: 16,
                  cursor: 'pointer'
                }}>{submenuOpen ? '▲' : '▼'}</span>
              )}
            </Link>
            <ul
              className="submenu"
              style={{
                display: menuOpen && submenuOpen ? 'block' : (!menuOpen ? 'none' : 'none'),
                background: '#fff',
                padding: '8px 0',
                borderRadius: 6,
                position: menuOpen ? 'static' : 'absolute',
                marginTop: 4,
                boxShadow: '0 2px 8px #0002'
              }}
            >
              <li><Link to="/products?type=sparkler" onClick={handleMenuLinkClick}>Sparklers</Link></li>
              <li><Link to="/products?type=flowerpot" onClick={handleMenuLinkClick}>Flower Pots</Link></li>
              <li><Link to="/products?type=rockets" onClick={handleMenuLinkClick}>Rockets</Link></li>
            </ul>
          </li>
          <li><Link to="/offers" onClick={handleMenuLinkClick}>Offers</Link></li>
          <li><Link to="/contact" onClick={handleMenuLinkClick}>Contact</Link></li>
        </ul>

        {/* Cart icon on the right */}
        <div className="header-contact" style={{
          display: 'flex',
          alignItems: 'center',
          marginLeft: 'auto',
          gap: 12,
          position: 'relative',
          minWidth: 48,
          height: 48,
          justifyContent: 'flex-end',
          zIndex: 30
        }}>
          <span style={{
            display: 'none',
            color: '#fff',
            fontWeight: 500,
            fontSize: 15
          }}>{contactName} {contactPhone}</span>
          <span style={{
            marginLeft: 16,
            cursor: 'pointer',
            position: 'relative',
            background: '#fff',
            borderRadius: '50%',
            padding: 2,
            boxShadow: '0 2px 8px #0002',
            width: 36,
            height: 36,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 31
          }} onClick={handleCartClick}>
            <img src="/images/cart-icon.jpg" alt="Cart" style={{ width: 28, height: 28, display: 'block', pointerEvents: 'auto' }} />
            {cartProductCount > 0 && (
              <span style={{
                position: 'absolute',
                top: 0,
                right: 0,
                background: '#FF4500',
                color: '#fff',
                borderRadius: '50%',
                padding: '2px 6px',
                fontSize: 12,
                fontWeight: 'bold',
                minWidth: 18,
                minHeight: 18,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                transform: 'translate(40%, -40%)'
              }}>{cartProductCount}</span>
            )}
          </span>
        </div>
      </nav>
  </header>
  );
};

export default Header;